// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PrescriberLicenseModel } from './prescriberLicenseModel';
import type { SharedAddressModel } from './sharedAddressModel';
import type { SharedContactPreferenceModel } from './sharedContactPreferenceModel';
import type { SharedEmailAddressModel } from './sharedEmailAddressModel';
import type { SharedExternalIdModel } from './sharedExternalIdModel';
import type { SharedGlobalIdModel } from './sharedGlobalIdModel';
import type { SharedPhoneModel } from './sharedPhoneModel';
import type { Moment } from 'moment';
import type { RequestFile } from '@trialcard/shared';

export class PrescriberModel {
    'prescriberId'?: number;
    'prescriberLicenses'?: Array<PrescriberLicenseModel>;
    'externalIds'?: Array<SharedExternalIdModel>;
    'addresses'?: Array<SharedAddressModel>;
    'phoneNumbers'?: Array<SharedPhoneModel>;
    'emailAddresses'?: Array<SharedEmailAddressModel>;
    'contactPreferences'?: Array<SharedContactPreferenceModel>;
    'globalIds'?: Array<SharedGlobalIdModel>;
    'firstName'?: string;
    'middleName'?: string;
    'lastName'?: string;
    'suffix'?: string;
    'nickname'?: string;
    'npi'?: string;
    'taxId'?: string;
    'note'?: string;
    'isActive'?: boolean;

    static discriminator: string | undefined = undefined;

    static additionalProperties = false;

    static attributeTypeMap: Array<{ name: string; baseName: string; type: string }> = [
        {
            "name":     "prescriberId",
            "baseName": "prescriberId",
            "type":     "number"
        },
        {
            "name":     "prescriberLicenses",
            "baseName": "prescriberLicenses",
            "type":     ""
        },
        {
            "name":     "externalIds",
            "baseName": "externalIds",
            "type":     ""
        },
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     ""
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     ""
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     ""
        },
        {
            "name":     "contactPreferences",
            "baseName": "contactPreferences",
            "type":     ""
        },
        {
            "name":     "globalIds",
            "baseName": "globalIds",
            "type":     ""
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "nickname",
            "baseName": "nickname",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "taxId",
            "baseName": "taxId",
            "type":     "string"
        },
        {
            "name":     "note",
            "baseName": "note",
            "type":     "string"
        },
        {
            "name":     "isActive",
            "baseName": "isActive",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return PrescriberModel.attributeTypeMap;
    }
}
